import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Home from "./Home";          // la tua “App generale matrimonio”
import QrApp from "./features/qr/QrApp"; // l’app QR incapsulata

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Home matrimonio */}
        <Route path="/" element={<Home />} />

        {/* App QR sotto /qr */}
        <Route path="/upload_photos" element={<QrApp />} />

        {/* fallback opzionale */}
        <Route path="*" element={
          <div style={{ padding: 24 }}>
            <p>Pagina non trovata</p>
            <Link to="/">Torna alla home</Link>
          </div>
        } />
      </Routes>
    </BrowserRouter>
  );
}
